import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart } from '@fortawesome/free-solid-svg-icons';
import { formatCurrency } from '../../utils/formatCurrency';
import { useScrollReveal } from '../../utils/hooks/useScrollReveal';

const CampaignCard = ({ campaign, index }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const cardRef = useScrollReveal();
  const progressPercentage = Math.round((campaign.current_amount / campaign.target_amount) * 100);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (cardRef.current) {
        const progressBar = cardRef.current.querySelector('.progress-bar');
        if (progressBar) {
          progressBar.style.width = `${progressPercentage}%`;
        }
      }
    }, 300 + index * 150);

    return () => clearTimeout(timer);
  }, [progressPercentage, index, cardRef]);

  return (
    <div ref={cardRef} className="campaign-card scroll-reveal">
      <div className="campaign-header">
        <h3 className="campaign-title">{campaign.title}</h3>
        <p className="campaign-hospital">{campaign.hospital}</p>
      </div>
      <div className="campaign-body">
        <div className="progress-info">
          <span className="amount-raised">{formatCurrency(campaign.current_amount, i18n.language)}</span>
          <span className="amount-target">{t('campaigns.target')}: {formatCurrency(campaign.target_amount, i18n.language)}</span>
        </div>
        <div className="progress-container">
          <div className="progress-bar" style={{ width: '0%' }}></div>
        </div>
        <p style={{ marginBottom: '1.5rem', color: '#64748b' }}>
          {campaign.description}
        </p>
        <button
          onClick={() => navigate(`/donate/${campaign.id}`)}
          className="donate-btn"
        >
          <FontAwesomeIcon icon={faHeart} /> {t('campaigns.donateNow')}
        </button>
      </div>
    </div>
  );
};

export default CampaignCard;
